import { DATE_FORMATS, parseDateForInput } from '@/utils/formUtils';

/**
 * Turns an employee from GET /employees/:id into the shape the employee form
 * expects (date strings → dayjs for the pickers). Shared by the edit page and
 * the profile page.
 */
export default function normalizeEmployeeFormData(employeeData) {
  if (!employeeData) return null;

  return {
    ...employeeData,
    employmentSettings: {
      ...employeeData?.employmentSettings,
      startDate:
        parseDateForInput(
          employeeData?.employmentSettings?.startDate,
          DATE_FORMATS.STANDARD
        ) ?? undefined,
      endDate:
        parseDateForInput(
          employeeData?.employmentSettings?.endDate,
          DATE_FORMATS.STANDARD
        ) ?? undefined,
      dateOfWorkPermissionForeigner:
        parseDateForInput(
          employeeData?.employmentSettings?.dateOfWorkPermissionForeigner,
          DATE_FORMATS.STANDARD
        ) ?? undefined,
    },
    additionalPersonalInfo: employeeData?.additionalPersonalInfo
      ? {
          ...employeeData.additionalPersonalInfo,
          birthDate:
            parseDateForInput(
              employeeData.additionalPersonalInfo.birthDate,
              DATE_FORMATS.STANDARD
            ) ?? undefined,
          familyCelebrationDate:
            parseDateForInput(
              employeeData.additionalPersonalInfo.familyCelebrationDate,
              DATE_FORMATS.STANDARD
            ) ?? undefined,
          workExperienceStartDate:
            parseDateForInput(
              employeeData.additionalPersonalInfo.workExperienceStartDate,
              DATE_FORMATS.STANDARD
            ) ?? undefined,
          previousEmployments:
            employeeData.additionalPersonalInfo.previousEmployments?.map(
              (emp) => ({
                ...emp,
                startDate:
                  parseDateForInput(emp.startDate, DATE_FORMATS.STANDARD) ??
                  undefined,
                endDate:
                  parseDateForInput(emp.endDate, DATE_FORMATS.STANDARD) ??
                  undefined,
              })
            ) ?? [],
          children:
            employeeData.additionalPersonalInfo.children?.map((child) => ({
              ...child,
              birthDate:
                parseDateForInput(child.birthDate, DATE_FORMATS.STANDARD) ??
                undefined,
            })) ?? [],
        }
      : undefined,
  };
}
